(function( $ ) {

"use strict";

var evt_to_marker = function(id,over)
{
    var m = markerarray[id];
    
	if (m.getAnimation() == null) {
	    m.setAnimation(google.maps.Animation.BOUNCE);
	} else {
	    m.setAnimation(null);
	}
}

function hide_searchoverlay(event) {

	event.stopPropagation();
	$('html').on('click',function(e) {
		
		if($('.title-wrapper').hasClass('active') && $('.input-active').length > 0)
			$('.title-wrapper').removeClass('active');

	});

	$(window).scroll(function() {
		$('.datepicker-field').datepicker('hide');
		$('.title-wrapper').removeClass('active');
	});
}

$(document).ready(function(){

	//counter

    setInterval(function() { makeTimer(); }, 3600*60);
    makeTimer();

	// sticky menu
	var offset = 0;
	if($('.logged-in').length > 0)
		offset = 32;

	$(".site-header").stick_in_parent({
	    offset_top:offset,
	});

	// Menu mobile trigger
	$('.btn-menu-mobile-trigger').on('click', function(){
		$('.menu-mobile').toggleClass('active');
	});

	// hover on menu items
	$('li.menu-item-has-children').hover(function(){
		$('.site-header').addClass('subactive');
	}, function(){
		$('.site-header').removeClass('subactive');
	});
	
	// search modal
	$(document).on('click','.search-toggle',
	
		function(e)
		{
			e.preventDefault();
			
			$('#modal-search .search-field').val('');
			
			// Show modal
			$('#modal-search').modal();
			
			// Add focus to search field
			$('#modal-search').off('shown.bs.modal');
			$('#modal-search').on('shown.bs.modal', function() {
    			$('#modal-search .search-field').focus();
			});
		}
	
	);

	// behavior when scrolling down
	var menuHeight = 63;
	var lastScrollTop = 0;
    $(window).scroll(function(event){
        var st = $(this).scrollTop();

        if (st > lastScrollTop){
               // going down
           	if (lastScrollTop >= menuHeight) {
            	$(".site-header").addClass("scrolldown");
            }
            $(".site-header").removeClass("scrollup");
        } else {
            // going up
            if (lastScrollTop >= menuHeight) {
            	$(".site-header").addClass("scrollup");
            }
            $(".site-header").removeClass("scrolldown");
        }
        lastScrollTop = st;
    });

    // event slider on HP
	$('.slider-soon-wrapper').slick({
	  	centerMode: true,
  		autoplay: true,
  		autoplaySpeed: 4000,
  		pauseOnFocus:false,
  		pauseOnHover:false,
  		centerPadding: '150px',
	  	slidesToShow: 5,
	  	slidesToScroll: 3,
	  	responsive: [
	    {
	      breakpoint: 1550,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 4,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 1200,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 3,
	        slidesToScroll: 3
	      }
	    },
	    {
	      breakpoint: 850,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        //centerPadding: '0px',
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 768,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        centerPadding: '220px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 650,
	      settings: {
	        //arrows: false,
	        centerMode: true,
	        centerPadding: '170px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 520,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '100px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    },
	    {
	      breakpoint: 440,
	      settings: {
	        arrows: false,
	        centerMode: true,
	        centerPadding: '25px',
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	  ]
	});

	// big slider bottom on HP
	$('.slider-image-wrapper').slick({
		infinite: true,
		slidesToShow: 1,
		dots: true,
		fade: true,
		speed: 800,
		appendArrows:$('.images-wrapper .slider-navigation'),
		appendDots:$('.images-wrapper .slider-navigation'),
	});
	
	// Autocomplete on filter by tag field
	$('select.select2').each(
	
		function() 
		{
        	var allowClearEnabled = false;

        	if($(this).find('option[value=""]').length) 
			{
         		allowClearEnabled = true;
            }
			
           	$(this).select2(
				{
             		allowClear: true,
					width: 'resolve',
                    //minimumResultsForSearch: 10,
                	//allowClear: allowClearEnabled
                }
			);

		}
	);
	if($('.select2-container').length > 0)
		$('.select2-container').fadeTo("slow", 1);


    // shadow on event sas page
	$('.datepicker-wrapper, .select2-container').on('click', function(event){
		$('.title-wrapper').addClass('active');
		$(this).addClass('input-active');
		hide_searchoverlay(event);
	});

	// init tabs on HP
	$('.news-menu-wrapper ul a').click(function (e) {
	  e.preventDefault()
	  $(this).tab('show')
	})

	// init masonry on HP
	if ($(window).width() > 768) {
		$('.masonry').masonry({
		  itemSelector: '.socialpost',
		  columnWidth: '.socialpost',
		  percentPosition: true
		});
	}

	// init medias gallery in single event
	if($('.img-gallery').length > 0 )
		$('.img-gallery').swipebox();
	
	// big slider bottom on HP
	$('.partners-slider').slick({
		infinite: true,
		slidesToShow: 5,
		arrows:true,
		autoplay: true,
  		autoplaySpeed: 4000,
  		responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    ]
	});

	// init datepicker in listing page
	if($('.datepicker-wrapper').length > 0){
		$.fn.datepicker.defaults.format = "dd/mm/yyyy";
		$('#fstart').datepicker({
			//format: 'dd/mm/yyyy',
			container: '#datepicker-wrapper-fstart',
			disableEntry: true,
			maxViewMode: "days",
			language: 'fr',
		});		
		$('#fend').datepicker({
			//format: 'dd/mm/yyyy',
			container: '#datepicker-wrapper-fend',
			disableEntry: true,
			maxViewMode: "days",
			language: 'fr',
		});
	}

	// animation on hover of event in listing event MAP
	$(".events-wrapper .event").on("hover",
        function()
        {
            var id = $(this).data("occurence");
            evt_to_marker(id,true);
            center_map( map );
        }
    );

	// sticky artist info in single-artist
	if($('.id-artist-inner').length > 0){
		$(".id-artist-inner").stick_in_parent({
		    offset_top:offset + 30,
		});
	}

	// 
	$('#gotodiscover, .smoothscroll').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 50
        }, 1000);
        return false;
      }
    }
  });

	// "discover more" slider
	$('.slider-events').slick({
		infinite:false,
	  	slidesToShow: 3,
	  	arrows: true,
	  	responsive: [
	    {
	      breakpoint: 768,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 2,
	        slidesToScroll: 2
	      }
	    },
	    {
	      breakpoint: 550,
	      settings: {
	      	dots:true,
	      	arrows: false,
	        slidesToShow: 1,
	        slidesToScroll: 1
	      }
	    }
	    ]
	});

	// gallery slider in single event
	$('.slider-images-place').slick({
	  	arrows: true,
	  	adaptiveHeight: false,
	});

	// gallery slider in single event
	$('.image-slide').slick({
	  	arrows: true,
	});

	// gallery en images
    if($('.gallery-wrapper').length > 0){
	   	$('.gallery-wrapper').lightGallery({
	        thumbnail:true,
	            youtubePlayerParams: {
		        modestbranding: 1,
		        showinfo: 0,
		        rel: 0,
		        controls: 0
		    },
		    vimeoPlayerParams: {
		        byline : 0,
		        portrait : 0,
		        //color : 'A90707'     
		    },
		    download:false,
	    });

	/*	var $grid = $('.gallery-wrapper').isotope({
			layoutMode: 'masonry',
			itemSelector: '.slide-image',
			masonry: {
                // percentPosition: true,
                columnWidth: '.slide-image.sizer',
                // gutter: 2,
                horizontalOrder: true
			},
            // layoutMode: 'masonryHorizontal',
            // itemSelector: '.slide-image',
            // masonryHorizontal: {
            //     rowHeight: 240,
            //     gutter: 2
            // },
		});*/
    }

});

    function makeTimer() {

        var endTime = new Date("4 April 2019 9:00:00 GMT+01:00");
        endTime = (Date.parse(endTime) / 1000);

        var now = new Date();
        now = (Date.parse(now) / 1000);

        var timeLeft = endTime - now;

        var days = Math.floor(timeLeft / 86400);
       var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
        var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
        var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

        if (hours < "10") { hours = "0" + hours; }
        if (minutes < "10") { minutes = "0" + minutes; }
        if (seconds < "10") { seconds = "0" + seconds; }

        $("#days").html("<span>J-</span>" + days);
        $("#hours").html(hours + "<span>Hours</span>");
        $("#minutes").html(minutes + "<span>Minutes</span>");
        $("#seconds").html(seconds + "<span>Seconds</span>");

    }




$(window).load(function(){

	// when init slider of events on HP is finished then show it
	$('.slider-soon-wrapper').fadeIn();

	// redo the masonry to give nice effect
	$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
		$('.masonry').masonry({
		  itemSelector: '.socialpost',
		  columnWidth: '.socialpost',
		  percentPosition: true
		});
	})

	// custom scroll for event listing MAP
	if($(".events-wrapper").length > 0) {
		$(".events-wrapper").mCustomScrollbar({
			setWidth : 480,
	    	axis:"y",
	    	mouseWheel:{ scrollAmount: 150 },
	    	//autoDraggerLength: false,
	    });
	}

	if($(".gallery-track").length > 0) {
		// $(".gallery-track").mCustomScrollbar({
		// 	axis:"x",
		// 	contentTouchScroll:true,
		// 	autoDraggerLength: true,
		// 	mouseWheel:{ scrollAmount: 240 },
		// 	scrollButtons:{
		// 		enable: true,
		// 		scrollAmount: 720,
		// 		scrollType: "stepped"
		// 	},
		// });
	}

});

})(jQuery);

